import React from "react";
import DraggableList from "./../DraggableList/DraggableList";

function RankingAllAnswer(props) {
	var options = [...props.answer];

	return (
		<div className="response-container">
			<DraggableList disabled={true} options={options} isAnswer={true} displayTooltip={false} />
			{props.isOpenEnd ? (
				<p className="answer-footnote">
					Adds to more than 100% due to multiple responses
					<br />
					(don't know/refused to answer/not sure is not shown)
				</p>
			) : (
				<p className="answer-footnote">(don't know/refused to answer/not sure is not shown)</p>
			)}
		</div>
	);
}

export default RankingAllAnswer;
